import { createSelector } from 'reselect';
import { redux } from 'Core/redux';
import { STORE_KEY, INITIAL_STATE } from './slice';

export const selectState = state => {
  const appState = state || redux.store.getState();
  return appState?.[STORE_KEY] || INITIAL_STATE;
};

export const selectWorkTicketData = state => selectState(state).data;
export const selectWorkTicketLoading = state => selectState(state).loading;
export const selectfetchWorkTicketLoading = state => selectState(state).workTicketLoading;
export const selectWorkTicketError = state => selectState(state).error;
export const selectWorkTicketFilterVisible = state => selectState(state).filterVisible;
export const selectWorkTicketFilters = state => selectState(state).filters;
export const selectFilterVisible = state => selectState(state).filterVisible;
export const selectTileView = state => selectState(state).tileView;
export const selectFilteredWorkTickets = createSelector(
  [selectWorkTicketData, selectWorkTicketFilters],
  (data, { searchText }) => {
    return data.filter(entry =>
      Object.keys(entry).some(key =>
        String(entry[key]).toLowerCase().includes(searchText.toLowerCase()),
      ),
    );
  },
);
